import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from "axios";
import {  GridItem  } from '@chakra-ui/react';
 
import SingleMenCard from '../Components/SingleMenCard';
 

const  MenWearDetails = () => {
  const [data, setData] = useState({});
  let {id}= useParams();
  console.log(id);
    const getData= async (id)=>{
        return axios({
            method : "get" ,
            url : `https://mock-api-server-2399.onrender.com/men/${id}`
        }).then((res)=> {
            console.log(res.data)
            setData(res.data)
        });
    }

    useEffect(() => {
      getData(id);
    }, [id])
    


  return (
            <GridItem>
                 <SingleMenCard  
                  key={data.id}
                  {...data}
                 />
            </GridItem>
 
  )
}

export default  MenWearDetails 


 